export default __webpack_public_path__ + "static/media/image-upload.2dfd7907.png";